<template>
    <div class="VueCarousel-slide" :style="slideStyle">
        <slot />
    </div>
</template>

<script>
// Slide component paired with the local carousel adapter.
export default {
    name: 'CarouselSlide',
    inject: {
        carousel: {
            default: null,
        },
    },
    computed: {
        slideStyle() {
            const width =
                this.carousel && this.carousel.slideWidth
                    ? this.carousel.slideWidth
                    : '100%';

            return {
                flex: `0 0 ${width}`,
                maxWidth: width,
            };
        },
    },
};
</script>

<style scoped>
.VueCarousel-slide {
    backface-visibility: hidden;
    flex-grow: 0;
    flex-shrink: 0;
    outline: none;
    user-select: none;
}
</style>
